import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function getPaymentConfig() {
  const res = await axios.get(`${API}/payment/config`);
  return res.data;
}

export async function createOrder() {
  const res = await axios.post(`${API}/payment/create-order`);
  return res.data;
}

export async function verifyPayment(payload) {
  const res = await axios.post(`${API}/payment/verify`, payload);
  return res.data;
}

// Signals ProtectionLayer that the Razorpay modal has closed so it can clear
// the "Content hidden — return to tab" overlay without requiring a manual
// window focus change.
function endPaymentFlight() {
  window.__paymentInFlight = false;
  try {
    window.focus();
    window.dispatchEvent(new Event("myresumedesign:payment-end"));
  } catch (e) {
    /* ignore */
  }
}

// Opens Razorpay checkout, resolves with the response on success, rejects on
// failure OR user cancel. The reject error carries a `.code` and `.detail`
// pulled from Razorpay's `payment.failed` event so the UI can show something
// more helpful than "Payment cancelled".
export function openCheckout({ orderId, keyId, amount, prefill = {} }) {
  return new Promise((resolve, reject) => {
    if (!window.Razorpay) return reject(new Error("Razorpay script not loaded"));
    window.__paymentInFlight = true;
    let userDismissed = true; // flipped to false once a handler/failure fires
    const rzp = new window.Razorpay({
      key: keyId,
      order_id: orderId,
      amount,
      currency: "INR",
      name: "MyResumeDesign",
      description: "Remove watermark from resume PDF",
      image: `${window.location.origin}/favicon.svg`,
      prefill,
      notes: { product: "resume_pdf_download" },
      theme: { color: "#2400FF" },
      modal: {
        ondismiss: () => {
          endPaymentFlight();
          if (userDismissed) reject(Object.assign(new Error("Payment cancelled"), { code: "cancelled" }));
        },
      },
      handler: (resp) => {
        userDismissed = false;
        endPaymentFlight();
        resolve(resp);
      },
    });
    // Surface Razorpay's real failure reason instead of a generic message.
    // Common codes: BAD_REQUEST_ERROR, GATEWAY_ERROR, PAYMENT_TIMEOUT_ERROR.
    rzp.on("payment.failed", (response) => {
      userDismissed = false;
      const err = response?.error || {};
      if (process.env.NODE_ENV === "development") console.error("[Razorpay] payment.failed", err);
      endPaymentFlight();
      const msg = err.description || err.reason || "Payment failed";
      const code = err.code || "unknown";
      reject(Object.assign(new Error(`${msg} (${code})`), { code, detail: err }));
    });
    rzp.open();
  });
}
